import type { FilterDefinitionValue } from '@carrefour-gcs/bff-sdk';
import { ANONYMIZED_LABEL_INDEX_PLACEHOLDER } from '@carrefour-gcs/shared';

/**
 * Numbers the masked labels sent to anonymized users with their 1-based position in the displayed
 * list, so two masked values never share the same label. Other labels are left untouched.
 * @example 'EAN {index} - *******' at the 3rd position → 'EAN 3 - *******'
 */
export function numberAnonymizedLabels(options: FilterDefinitionValue[]): FilterDefinitionValue[] {
  return options.map((option, index) =>
    option.label.includes(ANONYMIZED_LABEL_INDEX_PLACEHOLDER)
      ? { ...option, label: option.label.replace(ANONYMIZED_LABEL_INDEX_PLACEHOLDER, String(index + 1)) }
      : option
  );
}
